export enum CullMode {
    /** Disable culling. */
    Off = 0,
    /** cut the front-face of the polygons. */
    Front = 1,
    /** cut the back-face of the polygons. */
    Back = 2
  }

  export enum FrontFace{
    /** Clockwise front faces. */
    CW = 0,
    /** Counter-clockwise front faces. */
    CCW = 1
  }
  